import { IBalanceOfTrade, IRevenue } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

export const getNewFormatBalanceOfTrade = (
  balanceOfTrade?: IBalanceOfTrade[],
  revenue?: IRevenue[]
) => {
  if (!balanceOfTrade) {
    return []
  }
  if (!revenue) {
    return balanceOfTrade
  }

  const grandTotalForCurrentYear =
    revenue.find((el) => el.Key === 'GrandTotal')?.CurrentYearRevenue || 0

  const balanceOfTradeCurrentYear =
    balanceOfTrade.find((el) => el.Key === 'BalanceOfTrade')?.CurrentYearTotal ||
    grandTotalForCurrentYear
  const hpSpendValue = balanceOfTrade.find((el) => el.Key === 'HPSpend')?.CurrentYearTotal || 0
  const totalRevenue =
    balanceOfTrade.find((el) => el.Key === 'TotalRevenue')?.CurrentYearTotal ||
    balanceOfTradeCurrentYear - hpSpendValue

  return balanceOfTrade.map((el) => {
    if (el.Key === 'BalanceOfTrade') {
      return { ...el, CurrentYearTotal: balanceOfTradeCurrentYear }
    }
    if (el.Key === 'HPSpend') {
      return { ...el, CurrentYearTotal: hpSpendValue }
    }
    if (el.Key === 'TotalRevenue') {
      return { ...el, CurrentYearTotal: totalRevenue }
    }

    return el
  })
}
